export { default as DiseaseEncyclopedia } from './DiseaseEncyclopedia';
